import Page from '@cinch/oxd-pages/qna-search/src'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import getParam from '@somo/oxd-apps-www/src/utils/url-search-param'
import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { FAQPage } from 'schema-dts'
import SEO, { Breadcrumb } from '../components/seo'

const JargonPage: React.FC<{ location: Location }> = ({ location }) => {
  const data = useStaticQuery(graphql`
    query {
      allTranslations {
        edges {
          node {
            jargon {
              title
              resultsTitle
              recent
              noResultsTitle
            }
          }
        }
      }
      prismic {
        allJargons {
          edges {
            node {
              question
              summary
              _meta {
                uid
              }
            }
          }
        }
      }
    }
  `)

  const i18n = data.allTranslations.edges[0].node.jargon

  const latestJargon = data.prismic.allJargons.edges.map(
    ({
      node: {
        question: title,
        summary: subtitle,
        _meta: { uid: id },
      },
    }: any) => ({
      title,
      subtitle,
      id,
    }),
  )

  const faqSchema: FAQPage = {
    '@type': 'FAQPage',
    mainEntity: latestJargon.map(({ title, subtitle, id }: { title: string; subtitle: string; id: string }) => ({
      '@type': 'Question',
      name: title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: subtitle,
        url: `${getEnv(Env.SiteUrl)}/jargon/${id}`,
      },
    })),
  }

  const breadcrumbs: Breadcrumb[] = []

  if (location) {
    const pageUrl = `${getEnv(Env.SiteUrl)}${location.pathname}`
    breadcrumbs.push({
      name: i18n.title,
      item: pageUrl,
    })
  }

  return (
    <>
      <SEO title={i18n.title} breadcrumbs={breadcrumbs} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <Page query={getParam(location.search)('q')} latestJargon={latestJargon} i18n={i18n} />
    </>
  )
}

export default JargonPage
